import { motion } from "framer-motion";

export default function KineticHeadline({ lines, className }) {
  return (
    <h1 className={className} data-testid="hero-headline">
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.09em] -mb-[0.09em]">
          <motion.span
            className="block will-change-transform"
            initial={{ y: "112%" }}
            animate={{ y: "0%" }}
            transition={{
              duration: 0.95,
              delay: 0.2 + i * 0.13,
              ease: [0.16, 1, 0.3, 1],
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </h1>
  );
}
